import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
// import { Notification } from 'element-ui'
import { ACCESS_TOKEN, USER_MARKET } from '@/store/mutation-types'
import Cookies from 'js-cookie'
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  'login',
  // 'znwLogin',
  // 'newLogin',
  'forget-password',
] // no redirect whitelist

// 监听浏览器标签页隐藏或显示
document.addEventListener('visibilitychange', function () {
  if (!document.hidden) { // 当前标签页显示
    // 这里主要是考虑，开两个选项卡时，第二个选项卡登录另一用户，回来前一个选项卡时已经重新拿最新的token和userInfo
    store.dispatch('changeUser', store.state.user.info.userName)
  }
})

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar

  if (Cookies.get(ACCESS_TOKEN)) {
    if (store.state.user.permissibleMenu.length === 0) {
      store
        .dispatch('GetPermission')
        .then(permissibleMenu => {
          store.dispatch('GenerateRoutes', permissibleMenu).then(() => {
            // 根据roles权限生成可访问的路由表
            // 动态添加可访问路由表
            router.addRoutes(store.state.permission.addRouters)
          })
        })
        .catch(() => {
          Notification.error({
            title: '错误',
            meaasge: '请求用户信息失败，请重试'
          })
          store.dispatch('Logout').then(() => {
            next({ path: '/user/login', query: { redirect: to.fullPath } })
          })
        })
    }
    if (to.meta.action && to.meta.action.length === 0) {
      store
        .dispatch('GetAction', to.meta.menuId)
        .then((data) => {
          to.meta.action = data.map(item => item.menuCode)
          // next()
        })
    } else {
      next()
    }
    next()
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 如果是沐甜市场的用户退出登录的，那么重定向到登录页的时候，把市场id一起加上
      // const marketCodes = Vue.ls.get(USER_MARKET) || []
      // if (marketCodes.includes('000')) {
      //   next({ path: '/user/login', query: { redirect: to.fullPath, marketId: '000' } })
      // } else {
      //   next({ path: '/znwLogin/znwLogin', query: { redirect: to.fullPath } })
      // }
      // 新登录  marketId 用户判断是否显示老沐甜用户平台
      const marketCodes = Vue.ls.get(USER_MARKET) || []
      next({ path: '/user/login', query: marketCodes.includes('000') ? { redirect: to.fullPath, marketId: '000' } : { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <a-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg

    const actions = vnode.context.$route.meta.action
    if (actions && actions.indexOf(actionName) < 0) {
      setTimeout(() => {
        if (el.parentNode == null) {
          el.style.display = 'none'
        } else {
          el.parentNode.removeChild(el)
        }
      }, 10)
    }
  }
})

export {
  action
}
